

type parts = {
    name: string;
    mountings_type_pname: string;
    mountings_type_name: string;
    price_lock: number;
    mountings_unit_name: string;
    build_bonus_type: number;
    build_bonus_price: number | null;
    sell_bonus_type: number;
    sell_bonus_price: number | null;
    reappearance_type_name: string;
    describe: string;
    id: number;
};
type partsKey = keyof parts;
type formKey = keyof formType;
const columnList: Array<column> = [
    {
        prop: "name",
        label: "维修项目",
        width: 164,
    },
    {
        prop: "mountings_type_pname",
        label: "大类",
        width: 75,
    },
    {
        prop: "mountings_type_name",
        label: "小类",
        width: 75,
    },
    {
        prop: "middle_price",
        label: "工时费（中）",
        width: 75,
    },
    {
        prop: "build_bonus_price",
        label: "施工提成",
        width: 75,
    },
    {
        prop: "sell_bonus_price",
        label: "销售提成",
        width: 75,
    },
    {
        prop: "reappearance_type_name",
        label: "返现方案",
        width: 75,
    },
];

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import {
    getManagementTable,
    getManagementTableAdd,
    getManagementTableEdit,
    getSetManagement,
    getSelectList,
} from "@/api/http";
import { validateInput, validateClass } from "@/assets/js/formRules";
import {column} from "@/assets/types/common";
import { formType } from "@/assets/types/common";

export default defineComponent({
    name: "ProjectRepair",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["维修项目"]);
        const headClass = inject("headClass");
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<parts>),
            total = ref(0),
            loading = ref(true),
            // 筛选
            selectGroup = reactive({
                status: "",
                build_bonus_price: "",
                return_cash_plan: "",
                mountings_type_pname: "",
                mountings_type_name: "",
                search: "",
            }),
            select = reactive({
                mountings_ptype_data: [],
                mountings_type_data: [],
                reappearance_type_data: [],
                mountings_brand_data: [],
                mountings_unit_data: [],
            }),
            remote_loading = ref(false),
            selectParameter: any = reactive({
                page: currentPage.value,
                page_size: pageSize.value,
            }),
            dialogFormVisible = ref(false),
            dialogTitle = ref("新增维修项目"),
            formRef = ref(null),
            form = ref({
                name: "",
                mountings_type_pid: null,
                mountings_type_id: null,
                build_bonus_type: 1,
                build_bonus_price: null,
                sell_bonus_type: 1,
                sell_bonus_price: null,
                return_cash_plan: null,
                low_price: null,
                middle_price: null,
                high_price: null,
                describe: "",
            } as formType),
            commissionType = ref(["固定金额", "业绩比例", "毛利比例"]),
            isEdit = ref(false),
            rules = reactive({
                name: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput("请输入项目名称", value, callback);
                        },
                        trigger: "change",
                    },
                ],
                class: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: undefined,
                            callback: Function
                        ) => {
                            validateClass(rule, callback, form);
                        },
                        trigger: "change",
                    },
                ],
                low_price: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput("工时费（低）", value, callback);
                        },
                        trigger: "change",
                    },
                ],
                middle_price: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput("工时费（中）", value, callback);
                        },
                        trigger: "change",
                    },
                ],
                high_price: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput("工时费（高）", value, callback);
                        },
                        trigger: "change",
                    },
                ],
            });
        let handleSizeChange = (value: number): void => {
                pageSize.value = value;
                getTableData();
            },
            handleCurrentChange = (pageSize: number): void => {
                currentPage.value = pageSize;
                getTableData();
            },
            getTableData = (): void => {
                loading.value = true;
                getManagementTable(selectParameter).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                });
            },
            getSelectData = (data: {
                search?: string;
                type_pid?: number | null;
            }) => {
                getSelectList(data).then((res: any) => {
                    Object.assign(select, res?.content || {});
                    remote_loading.value = false;
                });
            },
            selectChange = (e: number, key: partsKey): void => {
                selectParameter[key] = e;
                if (!e) {
                    delete selectParameter[key];
                } else if (key == "mountings_type_pname") {
                    getSelectData({ type_pid: e });
                    return;
                }
                getTableData();
            },
            remoteBrand = (e: string) => {
                remote_loading.value = true;
                getSelectData({ search: e });
            },
            formSelectChange = (e: number) => {
                getSelectData({ type_pid: e });
                form.value.mountings_type_id = null;
            },
            bonusSelectChange = (type: boolean) => {
                if (type) {
                    form.value.build_bonus_price = null;
                } else {
                    form.value.sell_bonus_price = null;
                }
            },
            columnChange = (
                item: formType & { id: number; status: number },
                type: boolean
            ): void => {
                if (type) {
                    dialogTitle.value = "编辑维修项目";
                    isEdit.value = true;
                    dialogFormVisible.value = true;
                    let data: any = { ...form.value, id: 0 };
                    Object.keys(data).forEach((key) => {
                        data[key as formKey] = item[key as formKey];
                    });
                    form.value = data;
                    getSelectData({ type_pid: form.value.mountings_type_pid });
                } else {
                    getSetManagement({
                        id: item.id,
                        status: item.status == 1 ? 0 : 1,
                    }).then((res) => getTableData());
                }
            },
            submitForm = (): void => {
                (formRef.value as any).validate((valid: boolean) => {
                    if (valid) {
                        if (isEdit.value) {
                            // getManagementTableEdit(form.value).then((res) =>
                            //     getTableData()
                            // );
                        } else {
                            // getManagementTableAdd(form.value).then((res) =>
                            //     getTableData()
                            // );
                        }
                    }
                    dialogFormVisible.value = !valid;
                });
            };
        onMounted(() => {
            getTableData();
            getSelectData({});
        });
        watch(dialogFormVisible, (newValue, oldValue) => {
            if (oldValue) {
                form.value = {
                    name: "",
                    mountings_type_pid: null,
                    mountings_type_id: null,
                    build_bonus_type: 1,
                    build_bonus_price: null,
                    sell_bonus_type: 1,
                    sell_bonus_price: null,
                    return_cash_plan: null,
                    low_price: null,
                    middle_price: null,
                    high_price: null,
                    describe: "",
                };
                isEdit.value = false;
                dialogTitle.value = "新增维修项目";
                (formRef.value as any).resetFields();
            }
        });

        return {
            columnList,
            headClass,
            pageSize,
            currentPage,
            tableData,
            total,
            loading,
            selectGroup,
            select,
            remote_loading,
            dialogFormVisible,
            dialogTitle,
            formRef,
            form,
            commissionType,
            isEdit,
            rules,
            handleSizeChange,
            handleCurrentChange,
            selectChange,
            remoteBrand,
            formSelectChange,
            bonusSelectChange,
            columnChange,
            submitForm,
        };
    },
});
